import React, { Fragment } from "react";
import SwiperCore, { Autoplay, Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

SwiperCore.use([Navigation, Pagination, Autoplay]);
import type { NextPage } from "next";
import Image from "next/image";
import Layout from "../layout/layout";
import banner from "../assets/images/kishalaya.jpg";

import styles from "../styles/kishalaya.module.scss";

const Kishalaya: NextPage = () => {
  return (
    <Layout>
      <div className={styles.csr_banner}>
        <Image src={banner} alt="" width={2313} height={923} />
      </div>
      <section>
        <div className={styles.table}>
          <div className="container">
            <div className="table-responsive">
              <table className="mt-5 table table-bordered">
                <tbody>
                  <tr>
                    <th colSpan={4} className={styles.tab_h}>
                      PROJECT-KISHALAYA
                    </th>
                  </tr>
                  <tr>
                    <td colSpan={4} className="text-center">
                      SENCO GOLD AND DIAMONDS CSR INITIATIVES FOR EDUCATIONAL
                      SUPPORT TO UNDERPRIVILEGED STUDENTS(PRIMARY LEVEL)
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={4} className="text-center">
                      EXECUTED BY P C SEN CHARITABLE TRUST
                    </td>
                  </tr>
                  <tr>
                    <th>PROJECT INSIGHT</th>
                    <td colSpan={4}>
                      Our humble support to underprivileged students in pursuing
                      their basic education, either by extending one time or
                      monthly financial support, or by donating educational kits
                      and support system
                    </td>
                  </tr>
                  <tr>
                    <th>DURATION</th>
                    <td colSpan={4}>(2023-24, 2024-25, 2025-26)</td>
                  </tr>
                  <tr>
                    <th>PROJECT</th>
                    <td colSpan={4}>
                      SARADA-NIVEDITA VIDYATAN &amp; PRABHAT-SHANKAR SHISHU
                      UDYAN, in association with Alinan Ramakrishna Vivekananda
                      Yuva Sangha, Alinan, Purba Medinipur
                    </td>
                  </tr>
                  <tr>
                    <th className={styles.tab_h} colSpan={4}>
                      PROJECT IMPLEMENTATION PLAN
                    </th>
                  </tr>
                  <tr>
                    <th>SL NO</th>
                    <th>YEAR</th>
                    <th>LOCATION</th>
                    <th>Project Details</th>
                  </tr>
                  <tr>
                    <td>1</td>
                    <td>2023-24</td>
                    <td>Mayachar Island, Mahishadal Block, Purba Medinipur</td>
                    <td>
                      <ul>
                        <li>
                          Reconstruction of Creche-cum-Pre-Primary Education
                          Centre
                        </li>
                        <li>
                          Construction of Prabhat-Shaankar Shishu Udyan, play
                          area of the students of the creche-cum-Pre-Primary
                          Education, just opposite to the Centre.
                        </li>
                        <li>
                          Power Breakfast and educational kits and Medical Camp
                          (to be continued in the next financial year)
                        </li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <th colSpan={4} className={styles.tab_h}>
                      ONGOING PROJECTS
                    </th>
                  </tr>
                  <tr>
                    <th>SL NO</th>
                    <th>YEAR</th>
                    <th>LOCATION</th>
                    <th>Project Details</th>
                  </tr>
                  <tr>
                    <td>1</td>
                    <td>2023-24</td>
                    <td>Anandaa Nagar Development Society, Purulia</td>
                    <td>
                      Support to hostel underprivileged students pursuing school
                      and college education under the society
                    </td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td></td>
                    <td>Alinan, Purba Medinipur</td>
                    <td>Udbadhan Primary School</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td></td>
                    <td>
                      Vivekananda School &amp; Skill Development Centre, Bamon
                      Mollarchawk, South 24 Parganas
                    </td>
                    <td>One time support in Educational Kits etc</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td></td>
                    <td>Shivmandir Seva Pratisthan, Kolkata</td>
                    <td>
                      One time support in Educational Kits etc to an evening
                      school run by Shivmandir Seva Pratisthan
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Kishalaya;
